import { useQueryClient } from "@tanstack/react-query";
import { usePrivateMutation } from "@/lib/query/core/use-private-mutation";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminStoreSubscriptions } from "@/lib/query/core/invalidation";

type Input = { storeId: string; expectedRevision: number } & (
  | { action: "activate"; planId: string; expectedPlanUpdatedAt: string }
  | { action: "cancel"; timing: "IMMEDIATE" | "PERIOD_END" }
);

export function useStoreTierMutation() {
  const queryClient = useQueryClient();
  return usePrivateMutation({
    mutationFn: (input: Input) =>
      apiJsonClient(
        input.action === "activate"
          ? endpoints.admin.storeActivatePremium(input.storeId)
          : endpoints.admin.storeCancelPremium(input.storeId),
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(
            input.action === "activate"
              ? {
                  planId: input.planId,
                  expectedPlanUpdatedAt: input.expectedPlanUpdatedAt,
                  expectedRevision: input.expectedRevision,
                }
              : {
                  timing: input.timing,
                  expectedRevision: input.expectedRevision,
                },
          ),
        },
      ),
    // A stale revision is a safe conflict; refetch both the quote and state.
    onSettled: (_data, _error, input) =>
      invalidateAdminStoreSubscriptions(queryClient, input.storeId),
  });
}
